var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loadingTree
    ? _c("div", { attrs: { id: "order-tree-detail-container" } }, [
        _c(
          "div",
          { attrs: { id: "data-tree-container" } },
          [
            _c("data-tree", {
              attrs: { tree: _vm.tree },
              on: { "selected-element": _vm.handleClick },
            }),
          ],
          1
        ),
        _c("div", { attrs: { id: "selected-content" } }, [
          _c("iframe", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selectedContent,
                expression: "selectedContent",
              },
            ],
            attrs: { src: _vm.iframeSrc },
            on: {
              load: _vm.completedIframe,
              readystatechange: function () {
                return _vm.console.log("changing...")
              },
            },
          }),
          _vm.loadingContentSpinner
            ? _c("div", { staticClass: "loading-container" }, [
                _c("i", { staticClass: "el-icon-loading" }),
              ])
            : _vm._e(),
          !_vm.iframeSrc && !_vm.loadingContentSpinner
            ? _c("div", { staticClass: "loading-container" }, [
                _vm._v(" Select a level "),
              ])
            : _vm._e(),
        ]),
      ])
    : _c("div", { staticClass: "loading-container" }, [
        _c("i", { staticClass: "el-icon-loading" }),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }